var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dialog',{ref:"dialog",attrs:{"config":_vm.config,"visible":_vm.visible,"cancelDialog":_vm.cancelDialog,"confirmDialog":_vm.submitGroupForm,"isdeling":_vm.isdeling,"append":""}},[_c('div',{staticClass:"contentBox"},[_vm._v(" 禁用后企业将无法开票,请确认是否禁用该企业? ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }